import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const useCustomNavigate = () => {

    const navigate = useNavigate();

    const customNavigate = useCallback((path) => {
        navigate(path);
    }, [navigate]);

    return customNavigate;
};

export default useCustomNavigate 
